import type { Configuration } from '@/api'

export function filterConfigurationsByGroupId(
  configurations: Configuration[] | undefined,
  groupId: string
): Configuration[] {
  if (!configurations?.length) return []
  return configurations.filter((c) => c.groupId === groupId)
}

export function filterConfigurationsByMemberGroupIds(
  configurations: Configuration[] | undefined,
  memberGroupIds: Set<string>
): Configuration[] {
  if (!configurations?.length || memberGroupIds.size === 0) return []
  return configurations.filter(
    (c) => c.groupId != null && memberGroupIds.has(c.groupId)
  )
}
